<template>
    
<div class="borders text-center relative-position" :style="div_height">

    <p class="text-left q-px-sm full-width q-my-xs"><!--  :style="p_height" -->
        Signature {{ for_role }}<span v-if="is_signed" class="text-bold text-positive"> Effectuée</span>
    </p>

    <VPerfectSignature v-if=" ! loading"
                    ref="signaturePad"
                    :stroke-options="strokeOptions"
                    style="z-index: 99999!important"
                    :width="width"
                    :height="height"
                    :backgroundColor="backgroundColor"
                    :penColor="penColor"
                    @onEnd="signed()" />

    <q-spinner-dots v-else size="52px" />

    <div class="hidder" v-if="is_signed" :style="div_height + styles_hidder"></div>
</div>
                
<q-btn v-if="is_signed" label="Recommencer" @click="reset()" square no-caps dense outline size="sm" class="q-animate--fade" />

</template>

<script setup>
import { ref/* , computed */ } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";

// https://github.com/wobsoriano/v-perfect-signature
import { VPerfectSignature } from 'v-perfect-signature'

const props = defineProps({
    ref: String,
    for_role: String, // Expéditeur | Chauffeur | Destinataire
})

const emit = defineEmits(['signed'])

const signaturePad = ref()

let dataURL = null

let loading = ref(true)
let is_signed = ref(false)
let styles_hidder = 'z-index: 9999999!important; position: absolute; top:0;left:0;right:0;bottom:0; background-color: rgba(0,0,0,0.3)'

// let styles = ref('z-index: 999999999!important') NON

let width = ref('100%!important')
let height = ref('250px!important')
let div_height = ref('278px!important')
// let p_height = ref('20px!important')

let backgroundColor = ref('rgba(255,255,255,1)')// le fond Forcément en blanc    ! proto.$q.dark.isActive ? 'rgba(240,240,240,1)' : 'rgba(40,40,40,1)')
let penColor = ref('rgba(10,10,10,1)') // et forcément en noir..    ! proto.$q.dark.isActive ? 'rgba(10,10,10,1)' : 'rgba(225,225,225,1)')

const strokeOptions = {
  size: 2,          // default = 16     La taille de base (diamètre) du trait.
  thinning: 0.1,   // default = 0.75   L'effet de la pression sur la taille du trait.
  smoothing: 0.5,   // default = 0.5    Dans quelle mesure adoucir les bords du trait.
  streamline: 0.5,  // default = 0.5    Combien de rationaliser le trait.

//   simulatePressure: true, // par default // S'il faut simuler la pression en fonction de la vitesse.

//  others options -> https://github.com/steveruizok/perfect-freehand#options
}

onMounted(()=>{

    _.delay(()=>{
        // log('in ElectroSignature.vue', signaturePad.value, signaturePad_recipient.value)

        signaturePad.value?.resizeCanvas() //? Obligé, avec 'delay', sinon il s'affiche pas !?!?!

        loading.value = false

    }, 1000)
})


const signed = ()=>{

    is_signed.value = true

    dataURL = signaturePad.value?.toDataURL()

        // log('dataURL in ElectroSignature.vue @signed()',dataURL)

    emit('signed', dataURL)
}

const reset = ()=>{
    
    signaturePad.value?.clear()

    is_signed.value = false

    emit('signed', null)
}
</script>